import { Sheet, SheetClose, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { cn } from '@/utils/styles';

export { SheetClose as MobileSheetClose };

export interface MobileSheetProps {
  trigger: React.ReactNode;
  content: React.ReactNode;
  contentClassName?: string;
}

export function MobileSheet({ trigger, content, contentClassName }: MobileSheetProps) {
  return (
    <Sheet>
      <SheetTrigger>{trigger}</SheetTrigger>
      <SheetContent
        side="bottom"
        hasCloseButton={false}
        className={cn('bg-[#0C111D] border-t-0 min-h-[260px] pt-3 pb-14', contentClassName)}
      >
        <div className="flex flex-col">
          <div className="flex items-center justify-center mb-3">
            <div className="w-16 h-1 rounded-full bg-white/20"></div>
          </div>
          <div className="flex flex-col">{content}</div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
